export const PROGRESSION_CHART_COLORS = [
  "#007BFF",
  "#28A745",
  "#FD7E14",
  "#DC3545",
  "#6610F2",
  "#20C997",
  "#FFC107",
  "#6C757D",
];

/**
 * Los periodos del selector de graficas.
 *
 * Es una FUNCION y no una constante porque las etiquetas se traducen y el
 * valor no: `7d` viaja al servidor como filtro y tiene que seguir siendo `7d`
 * en todos los idiomas. Separar rotulo de valor es lo que impide que traducir
 * la pantalla rompa la consulta.
 *
 * Antes era una constante con "7 dias" escrito dentro, y se quedo sin traducir
 * justo por eso: no habia donde meter el traductor.
 */
export function opcionesDePeriodo(t) {
  return [
    { label: t("periodos.dias", { count: 7 }), value: "7d" },
    { label: t("periodos.dias", { count: 30 }), value: "30d" },
    { label: t("periodos.dias", { count: 90 }), value: "90d" },
    { label: t("periodos.todo"), value: "all" },
  ];
}
